var _line, _line2, _line3, _mask, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 115,
    viewBox: "0 0 222 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 51,
    x2: 60,
    y2: 51,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 174,
    y1: 114,
    x2: 222,
    y2: 114,
    stroke: "black",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: -0.00415039,
    y1: 170.5,
    x2: 59.9958,
    y2: 170.5,
    stroke: "black",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 230C74.102 230 89.0562 227.025 103.009 221.246C116.961 215.467 129.639 206.996 140.317 196.317C150.996 185.639 159.467 172.961 165.246 159.009C171.025 145.056 174 130.102 174 115C174 99.898 171.025 84.9438 165.246 70.9914C159.467 57.039 150.996 44.3615 140.317 33.6827C129.639 23.004 116.961 14.5331 103.009 8.75385C89.0561 2.97456 74.102 -1.14017e-06 59 0L59 115L59 230Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 230C74.102 230 89.0562 227.025 103.009 221.246C116.961 215.467 129.639 206.996 140.317 196.317C150.996 185.639 159.467 172.961 165.246 159.009C171.025 145.056 174 130.102 174 115C174 99.898 171.025 84.9438 165.246 70.9914C159.467 57.039 150.996 44.3615 140.317 33.6827C129.639 23.004 116.961 14.5331 103.009 8.75385C89.0561 2.97456 74.102 -1.14017e-06 59 0L59 115L59 230Z",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-4-inside-1_0_1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 114,
    r: 9,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNand);
export default __webpack_public_path__ + "static/media/nand.101fed654c5c353a09ac88ec28a053bb.svg";
export { ForwardRef as ReactComponent };